import React from 'react';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import Typography from '@mui/material/Typography';

import { FormElement } from './FormElement';

import type { HandleBlur, HandleChange } from 'src/form-utils';

export const SelectWithLabel = ({
    label,
    bottomText,
    value,
    onChange,
    onBlur,
    name,
    options,
    fullWidth = true,
    nonEmpty = false,
    error = false,
    disabled = false,
}: {
    label?: string;
    bottomText?: string | React.ReactElement;
    value: string | null | undefined;
    name: string;
    onChange: HandleChange;
    onBlur?: HandleBlur;
    options: Array<{value: string | number; label: string}>;
    fullWidth?: boolean;
    nonEmpty?: boolean;
    error?: boolean;
    disabled?: boolean;
}) => {
    return (
        <FormElement bottomText={bottomText} fullWidth={fullWidth} label={label}>
            <SelectWithoutLabel
                disabled={disabled}
                error={error}
                fullWidth={fullWidth}
                name={name}
                nonEmpty={nonEmpty}
                onBlur={onBlur}
                onChange={onChange}
                options={options}
                value={value}
            />
        </FormElement>
    );
};

export const SelectWithoutLabel = ({
    value,
    onChange,
    onBlur,
    name,
    options,
    fullWidth = true,
    nonEmpty = false,
    error = false,
    disabled = false,
}: {
    value: string | null | undefined;
    name: string;
    onChange: HandleChange;
    onBlur?: HandleBlur;
    options: Array<{value: string | number; label: string}>;
    fullWidth?: boolean;
    nonEmpty?: boolean;
    error?: boolean;
    disabled?: boolean;
}) => {
    return (
        <Select
            autoWidth={!fullWidth}
            disabled={disabled}
            displayEmpty={nonEmpty}
            error={error}
            fullWidth={fullWidth}
            name={name}
            onBlur={onBlur}
            onChange={onChange}
            size="small"
            value={value ?? undefined}
            variant="outlined"
            {...(nonEmpty && {
                displayEmpty: nonEmpty,
                multiple: false,
            })}
        >
            { //@ts-expect-error Strange because undefined can't be selected and null work...
                !nonEmpty && <MenuItem value={null}>&nbsp;</MenuItem>}
            {options.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                    <Typography noWrap variant="body1">{option.label}</Typography>
                </MenuItem>
            ))}
        </Select>
    );
};
